import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let parent_company_id = useDataValue({
    context: 'global',
    path: 'current_location.parent_company._id',
    viewPath: props.viewPath,
  })
  let location_uuid = useDataValue({
    context: 'automation',
    path: 'location_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      parent_company_id,
      location_uuid,
    },
  }
}
